import React, { useContext, useEffect, useState, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Button,
    FloatButton,
    Progress,
    Table,
    TableProps,
    Tag,
    Card,
    Space,
    Tooltip,
    Typography,
    Row,
    Col,
    Statistic,
    Input
} from "antd";
import { ColumnsType } from "antd/es/table";
import {
    BiArrowFromLeft,
    BiPlus,
    BiRefresh
} from "react-icons/bi";
import { FaCheck, FaEye, FaQuestionCircle, FaDatabase, FaEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { FileExcelOutlined, AreaChartOutlined, FireOutlined, GiftOutlined, CodeOutlined, PlayCircleOutlined, ThunderboltOutlined, SettingOutlined, TrophyOutlined } from "@ant-design/icons";
import { Switch, message } from "antd";
import BbddColors from "../../../../styles/BbddColors";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { GetUsuariIdActivitatsId } from "../../../../dao/GetUsuariIdActivitatsId";
import { GetUsuariIdActivitats } from "../../../../dao/GetUsuariIdActivitats";
import { GetPractica } from "../../../../dao/bbdd/GetPracticaId";
import { PutUsuariIdActivitatId } from "../../../../dao/PutUsuariIdActivitatId";
import { PostBbddActivitatIdProblema } from "../../../../dao/bbdd/PostBbddActivitatIdProblema";
import RevisioModal from "./RevisioModal";
import NouExerciciBbddModal from "./NouExerciciBbddModal";
import ImportarExercicisBbddExcelModal from "./ImportarExercicisBbddExcelModal";
import ConfiguracioTestsDissenyModal from "./ConfiguracioTestsDissenyModal";
import ConfiguracioTestsSqlModal from "./ConfiguracioTestsSqlModal";
import RecompensaSummaryModal, { RewardItem } from "../../../jutge/activitatsId/content/RecompensaSummaryModal";
import { IoOptions } from "react-icons/io5";
import { getIdeSqlUrl } from "../../ide/ideSqlTokenHelper";
import PremiosModal from "../../../jutge/activitatsId/content/PremiosModal";
import { GetProblemaRecompenses } from "../../../../dao/jutge/GetProblemaRecompenses";
import { GetUsuarisRecompensesProblema } from "../../../../dao/jutge/GetUsuarisRecompensesProblema";
import { PostClaimReward } from "../../../../dao/jutge/PostClaimReward";
import { GetJavamonConfig, getJavamonImage } from "../../../../dao/jutge/GetJavamonConfig";
import JavaMon from "../../../jutge/problemesId/content/JavaMon";

// Solo en desarrollo local: habilita el botón de forzar recompensa (ignora requisitos).
const IS_LOCALHOST = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const { Title, Text } = Typography;

const RecompensesTags: React.FC<{ id_problema: string; idActivitat?: string; ele: any; refreshKey?: number }> = ({ id_problema, idActivitat, ele, refreshKey = 0 }) => {
    const { user } = useContext(AuthContext);
    const isAlumne = user?.tipus === "2";
    const isCompleted = (ele?.progres ?? 0) >= 1;
    const [recs, setRecs] = useState<any[]>([]);
    const [usuaris, setUsuaris] = useState<any[]>([]);

    useEffect(() => {
        let mounted = true;
        GetProblemaRecompenses(id_problema, idActivitat, 'BBDD').then(res => {
            if (mounted && res && Array.isArray(res)) setRecs(res);
        }).catch(() => { });
        GetUsuarisRecompensesProblema(id_problema, idActivitat, 'BBDD').then(res => {
            if (mounted && res && Array.isArray(res)) setUsuaris(res);
        }).catch(() => { });
        return () => { mounted = false; };
    }, [id_problema, idActivitat, refreshKey]);

    if (!recs || recs.length === 0) return null;

    const myAttempts = ele?.intents || 0;

    const visibleItems = recs.map((r: any) => {
        let isExhausted = false;
        let exhaustionReason = '';
        let whoGotIt = '';
        let isClaimedByMe = false;

        const gotItUsers = usuaris.filter(u => {
            try {
                const uRewards = typeof u.rewards_json === 'string' ? JSON.parse(u.rewards_json) : u.rewards_json;
                return uRewards && Array.isArray(uRewards) && uRewards.some((ur: any) => ur.id === r.id);
            } catch (e) {
                return false;
            }
        });

        if (r.limit_quantity && r.limit_quantity > 0 && r.claimed_count >= r.limit_quantity) {
            isExhausted = true;
            exhaustionReason = 'Agotada';
            if (gotItUsers.length > 0) {
                whoGotIt = gotItUsers.map(u => u.nom).join(', ');
                exhaustionReason += ` (${whoGotIt})`;
            }
        } else if (r.intentos_min && myAttempts > 0 && myAttempts < r.intentos_min) {
            isExhausted = true;
            exhaustionReason = `Requereix ${r.intentos_min} intents (Llevas ${myAttempts})`;
        } else if (r.intentos_max && myAttempts > r.intentos_max) {
            isExhausted = true;
            exhaustionReason = `Límit d'intents superat (Màx ${r.intentos_max}, Llevas ${myAttempts})`;
        } else if (r.time_limit && ele?.tiempo_empleado_segundos && ele.tiempo_empleado_segundos > (r.time_limit * 60)) {
            isExhausted = true;
            const elapsedMin = Math.round(ele.tiempo_empleado_segundos / 60);
            exhaustionReason = `Temps límit superat (Màx ${r.time_limit} min, has trigat ${elapsedMin} min)`;
        }

        isClaimedByMe = gotItUsers.some(u => String(u.id) === String((user as any)?.id || (user as any)?.idUsuari));

        if (isAlumne) {
            if (r.tipo === 'JAVAMON_RANDOM' || r.tipo === 'JAVAMON_SEASON') {
                return null;
            }
            const isPuntuacioOrTrofeu = r.tipo === 'PUNTUACION' || r.tipo === 'TROFEO';
            if (!isPuntuacioOrTrofeu && !isCompleted && !isExhausted && !isClaimedByMe) {
                return null;
            }
        }

        let text = r.tipo === 'JAVAMON_RANDOM'
            ? 'Javamon Aleatori'
            : (r.tipo === 'JAVAMON_SEASON' ? 'Javamon de Temporada' : r.tipo);
        if (r.valor && r.valor > 1) text += ` x${r.valor}`;

        const hasImage = r.imagen && r.imagen.length > 0;
        let imgSrc = '';
        if (hasImage) {
            imgSrc = r.imagen.startsWith('data:') || r.imagen.startsWith('http') ? r.imagen : `data:image/png;base64,${r.imagen}`;
        } else if (r.id_item && !['PUNTUACION', 'JAVAMON_RANDOM', 'JAVAMON_SEASON'].includes(r.tipo)) {
            const apiUrl = process.env.REACT_APP_API_URL;
            let typeSegment = r.tipo.toLowerCase();
            if (typeSegment === "escudo") typeSegment = "escut";
            if (typeSegment === "arco") typeSegment = "arc";
            if (typeSegment === "shop_item") typeSegment = "shop";
            imgSrc = `${apiUrl}:8061/jutge/game/image/${typeSegment}/${r.id_item}`;
        }

        let content;
        let bgColor = "transparent";
        let borderColor = "gray";

        if (r.tipo === 'PUNTUACION') {
            content = <span style={{ color: 'gold', fontWeight: 'bold' }}>🪙 +{r.valor}</span>;
            bgColor = "black";
            borderColor = "#333";
        } else if (r.tipo === 'JAVAMON_RANDOM') {
            content = <span>⚔️</span>;
            bgColor = "#fff";
            borderColor = "#d9363e";
        } else if (r.tipo === 'JAVAMON_SEASON') {
            content = <span style={{ color: '#722ed1', fontWeight: 'bold' }}>❓</span>;
            bgColor = "#f9f0ff";
            borderColor = "#722ed1";
        } else if (imgSrc) {
            content = <img src={imgSrc} alt={r.tipo} style={{ width: 16, height: 16, objectFit: 'contain', borderRadius: r.tipo.includes('JAVAMON') ? '50%' : '0' }} />;
        } else {
            content = <span>🎁</span>;
        }

        return {
            ...r,
            renderedContent: content,
            tooltipTitle: isExhausted ? exhaustionReason : text,
            isExhausted,
            exhaustionReason,
            bgColor,
            borderColor,
            grupoNum: Number(r.grupo_seleccion) || 0
        };
    }).filter(Boolean);

    const groupedElements: React.ReactNode[] = [];
    const processedGroupIds = new Set<number>();

    visibleItems.forEach((item: any, idx: number) => {
        if (item.grupoNum > 0) {
            if (processedGroupIds.has(item.grupoNum)) return;
            processedGroupIds.add(item.grupoNum);

            const groupItems = visibleItems.filter((x: any) => x.grupoNum === item.grupoNum);
            const allExhausted = groupItems.every((x: any) => x.isExhausted);
            const groupTooltip = (
                <div>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>🎯 Recompensa unificada (Tria 1 del Grup {item.grupoNum}):</div>
                    {groupItems.map((gi: any, gIdx: number) => (
                        <div key={gi.id || gIdx}>• {gi.tooltipTitle}</div>
                    ))}
                </div>
            );

            groupedElements.push(
                <Tooltip key={`group-${item.grupoNum}`} title={groupTooltip}>
                    <Tag
                        style={{
                            fontSize: '0.75rem',
                            borderRadius: '8px',
                            padding: '0 6px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '4px',
                            background: '#f0f5ff',
                            border: '1px solid #adc6ff',
                            cursor: 'help',
                            opacity: allExhausted ? 0.4 : 1,
                            filter: allExhausted ? 'grayscale(100%)' : 'none'
                        }}
                    >
                        <span style={{ fontSize: '10px', color: '#1d39c4', fontWeight: 600, marginRight: 2 }}>
                            G{item.grupoNum}:
                        </span>
                        {groupItems.map((gi: any, gIdx: number) => (
                            <span
                                key={gi.id || gIdx}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    opacity: gi.isExhausted ? 0.35 : 1,
                                    textDecoration: gi.isExhausted ? 'line-through' : 'none'
                                }}
                            >
                                {gi.renderedContent}
                            </span>
                        ))}
                    </Tag>
                </Tooltip>
            );
        } else {
            groupedElements.push(
                <Tooltip key={item.id || idx} title={item.tooltipTitle}>
                    <Tag
                        color={item.bgColor}
                        style={{
                            fontSize: '0.75rem',
                            borderRadius: '8px',
                            padding: '0 4px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: `1px solid ${item.borderColor}`,
                            cursor: 'help',
                            opacity: item.isExhausted ? 0.4 : 1,
                            textDecoration: item.isExhausted ? 'line-through' : 'none',
                            filter: item.isExhausted ? 'grayscale(100%)' : 'none'
                        }}
                    >
                        {item.renderedContent}
                    </Tag>
                </Tooltip>
            );
        }
    });

    return (
        <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
            {groupedElements}
        </div>
    );
};

const ActivitatsIdExercicis = () => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne, setUser } = useContext(AuthContext);
    const { id_activitat } = useParams();
    const [dades, setDades] = useState<any[]>([]);
    const [activitat, setActivitat] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalNuevo, setModalNuevo] = useState(false);
    const [importExcelVisible, setImportExcelVisible] = useState(false);
    const [configTestsModalVisible, setConfigTestsModalVisible] = useState(false);
    const [configTestsExercise, setConfigTestsExercise] = useState<any>(null);
    const [configSqlTestsModalVisible, setConfigSqlTestsModalVisible] = useState(false);
    const [configSqlTestsExercise, setConfigSqlTestsExercise] = useState<any>(null);
    const [selected, setSelected] = useState<any>();
    const [searchText, setSearchText] = useState('');
    const [modoDesafio, setModoDesafio] = useState<boolean>(() => {
        const stored = localStorage.getItem('lanterns_modo_desafio');
        if (stored !== null) return stored === 'true';
        return Boolean((user as any)?.modoDesafio === 1 || (user as any)?.modoDesafio === true);
    });

    const handleToggleModoDesafio = async (checked: boolean) => {
        setModoDesafio(checked);
        localStorage.setItem('lanterns_modo_desafio', String(checked));
        try {
            await import('../../../../dao/PutModoDesafio').then(m => m.PutModoDesafio(userId, checked));
            if (setUser) {
                setUser({ ...(user as any), modoDesafio: checked ? 1 : 0 });
            }
            import("antd").then(({ message }) => message.success(`Modo Desafío ${checked ? 'Activat' : 'Desactivat'}`));
        } catch (e) {
            console.warn("Could not persist modoDesafio to user profile:", e);
        }
    };
    const [recompensaModalVisible, setRecompensaModalVisible] = useState(false);
    const [recompensaItems, setRecompensaItems] = useState<RewardItem[]>([]);
    const [selectableMode, setSelectableMode] = useState(false);
    const [selectionOptions, setSelectionOptions] = useState<any[]>([]);
    const [pendingSelectionItem, setPendingSelectionItem] = useState<any>(null);
    const [rankingsVisible, setRankingsVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [showBattle, setShowBattle] = useState(false);
    const [battleJavamon, setBattleJavamon] = useState<any>(null);
    const [pendingJavamonBattle, setPendingJavamonBattle] = useState<any>(null);
    const [activeRewardData, setActiveRewardData] = useState<any>(null);
    const navigate = useNavigate();

    const isTeacher = ["0", "1"].includes(user?.tipus);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_activitat]);

    async function checkDades() {
        setLoading(true);
        const act = await GetPractica(id_activitat + "");

        const isStudent = user.tipus !== "0" && user.tipus !== "1";
        if (isStudent) {
            const estatNum = Number(act?.estat ?? -1);
            // No visible (0) o No actiu (1) → redirigir (l'alumne no hi ha de poder entrar).
            // Tancat (2) → SÍ pot entrar, però en mode REVISIÓ: pot veure els exercicis i la nota
            //   amb la icona de l'ull, però no fer-los (el botó d'accedir ja depèn de estat===3).
            const estatBloquejat = !act || estatNum === 0 || estatNum === 1;

            if (estatBloquejat) {
                navigate('/database/activitats');
                return;
            }
        }

        setActivitat(act);
        const data = await GetUsuariIdActivitatsId(userId + "", id_activitat + "");
        const prac = await GetUsuariIdActivitats(userId);
        const actividad = prac?.find((a: any) => a.id === Number(id_activitat));

        // Si és un examen, el breadcrumb i el "tornar enrere" han d'apuntar a /database/examens.
        const esExamen = Boolean(
            act?.isExamen || Number(act?.is_examen) === 1 ||
            actividad?.is_examen === 1 || actividad?.isExamen === 1
        );
        const parentLabel = esExamen ? 'exàmens' : 'activitats';
        const parentNav = esExamen ? '/database/examens' : '/database/activitats';

        setBreadCrumb(
            [
                { nom: 'Home', nav: '/home' },
                { nom: 'bbdd', nav: '/database' },
                { nom: parentLabel, nav: parentNav },
                { nom: `${actividad?.nom || 'Activitat'}`, nav: `/database/activitats/${id_activitat}` }
            ],
            true
        );
        setDades(data || []);
        setLoading(false);
    }

    function checkElement(ele: any) {
        setSelected(ele);
        setModal(true);
    }

    function closeModal() {
        setModal(false);
        setLoading(false);
    }

    function handleNuevo(ele?: any) {
        setSelected(ele || { id: 0, tipus: 'SQL', dificultat: 'beginner' });
        setModalNuevo(true);
    }

    function closeNouModal(updated: boolean) {
        setModalNuevo(false);
        if (updated) checkDades();
    }

    async function reclamar(ele: any) {
        setLoading(true);
        await PutUsuariIdActivitatId(userId + "", ele.id + "");
        await checkDades();
    }

    function potVeureTrofeus(ele: any) {
        if (user.tipus === "0" || user.tipus === "1") return true;
        if (alumne?.alumne?.repetidor) return false;

        if (!ele.inici) return true;
        const avui = new Date(ele.now || new Date());
        const inici = new Date(ele.inici);
        return avui >= inici;
    }

    function openPremiosModal(ele: any) {
        setSelected(ele);
        setRankingsVisible(true);
    }

    async function closeModalRanking(refresh: boolean) {
        setRankingsVisible(false);
        if (refresh) {
            await checkDades();
            setRefreshKey(prev => prev + 1);
        }
    }

    const resolveJavamonEncounter = async (recompensesList: any[]) => {
        const javamonRec = (recompensesList || []).find((r: any) =>
            r.tipo === 'JAVAMON' || r.tipo === 'JAVAMON_RANDOM' || r.tipo === 'JAVAMON_SEASON'
        );
        if (!javamonRec) return null;

        const data = await GetJavamonConfig();
        if (!data) return null;

        const rarities = data.rarities && data.rarities !== "null" ? JSON.parse(data.rarities) : [];
        const allJavamons = data.javamons && data.javamons !== "null" ? JSON.parse(data.javamons) : [];

        if (javamonRec.tipo === 'JAVAMON' && javamonRec.id_item) {
            const found = allJavamons.find((jm: any) => String(jm.id) === String(javamonRec.id_item));
            if (found) {
                const rFound = rarities.find((r: any) => r.id === found.id_rarity);
                return { jmChosen: found, rarityName: rFound?.nom || 'normal' };
            }
        }

        const seasonId = javamonRec.tipo === 'JAVAMON_SEASON' && javamonRec.id_item ? javamonRec.id_item : activitat?.id_season;
        let candidateJavamons = allJavamons.filter((jm: any) =>
            jm.active && (!seasonId || String(jm.id_season) === String(seasonId))
        );
        if (candidateJavamons.length === 0) {
            candidateJavamons = allJavamons.filter((jm: any) => jm.active);
        }
        const activeRarities = rarities.filter((r: any) => r.active);
        if (activeRarities.length === 0 || candidateJavamons.length === 0) return null;

        const totalRarityChance = activeRarities.reduce((sum: number, r: any) => sum + (Number(r.chance) || 0), 0);
        const rndRarity = Math.random() * (totalRarityChance > 0 ? totalRarityChance : 100);
        let rarityChosen = activeRarities[0];
        let accumR = 0;
        for (let c of activeRarities) {
            accumR += (Number(c.chance) || 0);
            if (rndRarity <= accumR) {
                rarityChosen = c;
                break;
            }
        }

        let availableOfRarity = candidateJavamons.filter((jm: any) => jm.id_rarity === rarityChosen.id);
        if (availableOfRarity.length === 0) availableOfRarity = candidateJavamons;

        const totalJmChance = availableOfRarity.reduce((sum: number, j: any) => sum + (Number(j.chance) || 0), 0);
        const rndJavamon = Math.random() * (totalJmChance > 0 ? totalJmChance : 100);
        let jmChosen = availableOfRarity[0];
        let accumJ = 0;
        for (let j of availableOfRarity) {
            accumJ += (Number(j.chance) || 0);
            if (rndJavamon <= accumJ) {
                jmChosen = j;
                break;
            }
        }

        return jmChosen ? { jmChosen, rarityName: rarityChosen?.nom || 'normal' } : null;
    };

    const handleClaimRewardClick = async (ele: any) => {
        const id_problema = ele.id + "";
        try {
            message.loading({ content: "Revisant recompenses...", key: "claim" });
            const recompensas = await GetProblemaRecompenses(id_problema, id_activitat + "", "BBDD");

            const groupedRewards = (recompensas || []).filter((r: any) => Number(r.grupo_seleccion) > 0);
            if (groupedRewards.length > 0) {
                message.destroy("claim");
                setSelectionOptions(groupedRewards);
                setPendingSelectionItem(ele);
                setSelectableMode(true);
                setRecompensaModalVisible(true);
                return;
            }

            const baseNonJavamonRewards = (recompensas || []).filter((r: any) => !r.tipo || !r.tipo.startsWith('JAVAMON'));
            const encounter = await resolveJavamonEncounter(recompensas || []);

            if (encounter && encounter.jmChosen) {
                const { jmChosen, rarityName } = encounter;
                const claimRes = await PostClaimReward(id_activitat + "", id_problema, userId + "", undefined, jmChosen.id + "", false, null, "BBDD");
                if (!claimRes || claimRes.status !== 'ok') {
                    message.error({ content: claimRes?.message || "Error al reclamar la recompensa", key: "claim" });
                    return;
                }

                message.destroy("claim");
                checkDades();
                setRefreshKey(prev => prev + 1);

                setPendingJavamonBattle({
                    idProblema: id_problema,
                    javamon: {
                        id: jmChosen.id,
                        name: jmChosen.nom,
                        image: getJavamonImage(jmChosen),
                        rarity: rarityName
                    }
                });

                setSelectableMode(false);
                setRecompensaItems([
                    ...baseNonJavamonRewards,
                    { tipo: 'JAVAMON', data: jmChosen }
                ]);
                setRecompensaModalVisible(true);
                return;
            }

            const res = await PostClaimReward(id_activitat + "", id_problema, userId + "", undefined, undefined, false, null, "BBDD");
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "Recompensa reclamada amb èxit", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                setRecompensaModalVisible(true);
                checkDades();
                setRefreshKey(prev => prev + 1);
            } else {
                message.error({ content: res?.message || "Error al reclamar la recompensa", key: "claim" });
            }
        } catch (e: any) {
            console.error("Error al reclamar recompensa:", e);
            message.error({ content: e?.message || "Error de xarxa", key: "claim" });
        }
    };

    // [LOCALHOST] Fuerza la obtención de recompensa ignorando requisitos (resolución,
    // intentos, tiempo, nota mínima). Reutiliza el modal de selección de grupo si procede.
    const handleForceClaimRewardClick = async (ele: any) => {
        const id_problema = ele.id + "";
        try {
            message.loading({ content: "[LOCALHOST] Forçant recompensa...", key: "claim" });
            const recompensas = await GetProblemaRecompenses(id_problema, id_activitat + "", "BBDD");

            const groupedRewards = (recompensas || []).filter((r: any) => Number(r.grupo_seleccion) > 0);
            if (groupedRewards.length > 0) {
                message.destroy("claim");
                setSelectionOptions(groupedRewards);
                setPendingSelectionItem({ ...ele, __force: true });
                setSelectableMode(true);
                setRecompensaModalVisible(true);
                return;
            }

            const res = await PostClaimReward(id_activitat + "", id_problema, userId + "", undefined, undefined, false, null, "BBDD", true);
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "[LOCALHOST] Recompensa forçada amb èxit", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                setRecompensaModalVisible(true);
                checkDades();
                setRefreshKey(prev => prev + 1);
            } else {
                message.error({ content: res?.message || "Error al forçar la recompensa", key: "claim" });
            }
        } catch (e: any) {
            console.error("Error al forçar recompensa:", e);
            message.error({ content: e?.message || "Error de xarxa", key: "claim" });
        }
    };

    const handleConfirmSelection = async (chosenReward: any) => {
        if (!pendingSelectionItem) return;
        const id_problema = pendingSelectionItem.id + "";
        const forceSelection = !!(pendingSelectionItem as any)?.__force;
        try {
            message.loading({ content: "Reclamant la teva selecció...", key: "claim" });

            if (chosenReward.tipo && chosenReward.tipo.startsWith('JAVAMON')) {
                const encounter = await resolveJavamonEncounter([chosenReward]);
                if (encounter && encounter.jmChosen) {
                    const { jmChosen, rarityName } = encounter;
                    const res = await PostClaimReward(id_activitat + "", id_problema, userId + "", undefined, jmChosen.id + "", false, chosenReward.id, "BBDD");
                    if (res && res.status === 'ok') {
                        message.success({ content: res.message || "¡Recompensa triada amb èxit!", key: "claim" });
                        setSelectableMode(false);
                        setPendingJavamonBattle({
                            idProblema: id_problema,
                            javamon: {
                                id: jmChosen.id,
                                name: jmChosen.nom,
                                image: getJavamonImage(jmChosen),
                                rarity: rarityName
                            }
                        });
                        setRecompensaItems([{ tipo: 'JAVAMON', data: jmChosen }]);
                        checkDades();
                        setRefreshKey(prev => prev + 1);
                        return;
                    }
                }
            }

            const res = await PostClaimReward(id_activitat + "", id_problema, userId + "", undefined, undefined, false, chosenReward.id, "BBDD", forceSelection);
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "¡Recompensa triada i obtinguda amb èxit!", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                checkDades();
                setRefreshKey(prev => prev + 1);
            } else {
                message.error({ content: res?.message || "Error al reclamar la recompensa seleccionada", key: "claim" });
            }
        } catch (e: any) {
            message.error({ content: e?.message || "Error al reclamar", key: "claim" });
        }
    };

    const onBattleSuccess = async () => {
        if (activeRewardData && battleJavamon) {
            const res = await PostClaimReward(
                activeRewardData.idActivitat,
                activeRewardData.idProblema,
                activeRewardData.userId,
                battleJavamon.id + "",
                undefined,
                false,
                null,
                "BBDD"
            );
            if (res && res.status === 'ok') {
                message.success(res.message);
                checkDades();
                setRefreshKey(prev => prev + 1);
            } else {
                message.error("Error al reclamar la recompensa després de la captura");
            }
        }
    };
    async function _unusedCleanup() {
        await checkDades();
    }

    // Summary statistics like Jutge
    const stats = useMemo(() => {
        const total = dades.length;
        if (total === 0) return { total: 0, completed: 0, avgProgress: 0, attempts: 0 };

        let sumProg = 0;
        let completed = 0;
        let attempts = 0;

        dades.forEach((d: any) => {
            const prog = (d.progres || 0) * 100;
            sumProg += prog;
            if (prog >= 100) completed++;
            attempts += (d.intents || 0);
        });

        return {
            total,
            completed,
            avgProgress: Math.round(sumProg / total),
            attempts
        };
    }, [dades]);

    // Search filter
    const filteredDades = useMemo(() => {
        if (!searchText.trim()) return dades;
        const q = searchText.toLowerCase();
        return dades.filter((item: any) => {
            const nom = (item.prac || item.nom || '').toLowerCase();
            const desc = (item.enunciat || item.descripcio || '').toLowerCase();
            const tipus = (item.tipus || '').toLowerCase();
            return nom.includes(q) || desc.includes(q) || tipus.includes(q);
        });
    }, [dades, searchText]);

    const getTipusTagColor = (tipus: string) => {
        switch (tipus?.toUpperCase()) {
            case 'ER': return 'purple';
            case 'SCRIPT': return 'cyan';
            case 'RELACIONAL': return 'blue';
            case 'DDL': return 'geekblue';
            case 'SQL': return 'green';
            case 'PLSQL': return 'volcano';
            case 'DCL': return 'orange';
            case 'NOSQL': return 'magenta';
            default: return 'default';
        }
    };

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 70,
            align: 'center',
            title: '#',
            render: (id) => <Tag color={BbddColors.colors.color5}>#{id}</Tag>
        },
        {
            key: 'prac',
            dataIndex: 'prac',
            width: 200,
            title: 'Exercici',
            render: (text: string, ele: any) => (
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text strong style={{ fontSize: 14 }}>{text || ele.nom || `Exercici ${ele.id}`}</Text>
                        {ele.tipus && (
                            <Tag color={getTipusTagColor(ele.tipus)} style={{ fontWeight: 600 }}>
                                {ele.tipus}
                            </Tag>
                        )}
                        {ele.dificultat && (
                            <Tag color={ele.dificultat === 'expert' ? 'red' : ele.dificultat === 'intermediate' ? 'orange' : 'green'}>
                                {ele.dificultat}
                            </Tag>
                        )}
                    </div>
                    {ele.enunciat && (
                        <div style={{ fontSize: 12, color: '#777', marginTop: 4, maxWidth: 500 }}>
                            {ele.enunciat.length > 110 ? ele.enunciat.substring(0, 110) + '...' : ele.enunciat}
                        </div>
                    )}
                    <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
                        <RecompensesTags
                            id_problema={ele.id + ""}
                            idActivitat={id_activitat + ""}
                            ele={ele}
                            refreshKey={refreshKey}
                        />
                    </div>

                    {/* 🏆 TROFEOS i PUNTUACIÓ */}
                    {potVeureTrofeus(ele) &&
                        ((ele.trofeus && ele.trofeus.length > 0) || (ele.puntuacion > 1)) && (
                            <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                                {ele.puntuacion > 1 && (
                                    <Tooltip title={`Per completar aquest exercici es guanyen ${ele.puntuacion} punts de prestigi`}>
                                        <Tag
                                            color="black"
                                            style={{
                                                fontSize: '0.75rem',
                                                borderRadius: '8px',
                                                padding: '0 6px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                border: '1px solid #333',
                                                cursor: 'help'
                                            }}
                                        >
                                            +{ele.puntuacion} <TrophyOutlined style={{ color: 'gold', fontSize: '10px' }} />
                                        </Tag>
                                    </Tooltip>
                                )}
                                {ele.trofeus && ele.trofeus.map((t: any) => {
                                    const isClaimed = t.claimed === 1;
                                    const isMe = t.is_me === 1;
                                    let tooltip = isClaimed ? `Guanyador: ${t.winner}` : "Disponible";
                                    if (isMe) tooltip = "🏆 Guanyat per tu!";

                                    return (
                                        <Tooltip key={t.id} title={tooltip}>
                                            <Tag
                                                color={t.color}
                                                style={{
                                                    fontSize: '0.75rem',
                                                    borderRadius: '8px',
                                                    padding: '0 6px',
                                                    fontWeight: 'bold',
                                                    textDecoration: isClaimed && !isMe ? 'line-through' : 'none',
                                                    opacity: isClaimed && !isMe ? 0.6 : 1,
                                                    border: isMe ? '2px solid gold' : '1px solid transparent',
                                                    boxShadow: isMe ? '0 0 4px gold' : 'none',
                                                }}
                                            >
                                                {t.nom} {isMe && "👑"}
                                            </Tag>
                                        </Tooltip>
                                    );
                                })}
                            </div>
                        )}
                    {ele.tags && (
                        <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {(Array.isArray(ele.tags) ? ele.tags : String(ele.tags).split(/[\s,]+/))
                                .map((t: string) => t.trim())
                                .filter(Boolean)
                                .map((tagStr: string, idx: number) => (
                                    <Tag
                                        key={`tag-${idx}`}
                                        style={{
                                            background: '#f0f5ff',
                                            border: '1px solid #adc6ff',
                                            color: '#1d39c4',
                                            borderRadius: 10,
                                            padding: '0 6px',
                                            fontSize: '0.7rem',
                                            fontWeight: 500,
                                            margin: 0
                                        }}
                                    >
                                        #{tagStr}
                                    </Tag>
                                ))}
                        </div>
                    )}
                </div>
            )
        },
        {
            key: 'progres',
            dataIndex: 'progres',
            width: 120,
            align: 'center',
            title: 'Progrés / Nota',
            render: (e, ele) => {
                // La nota real de l'exercici és `ele.nota` (0-100). `ele.progres` del backend és
                // un count d'enviaments correctes (estat=2) i val 0 per a exercicis parcials o de
                // disseny -> no s'ha de fer servir com a percentatge. Prioritzem `ele.nota`.
                const notaNum = (ele.nota !== null && ele.nota !== undefined && !Number.isNaN(Number(ele.nota)))
                    ? Math.max(0, Math.min(100, Number(ele.nota)))
                    : null;
                const progreso = notaNum !== null ? Math.round(notaNum) : Math.round((ele.progres || 0) * 100);
                const hecho = notaNum !== null ? notaNum >= 100 : (ele.progres || 0) * 100 >= 100;

                // En un EXAMEN, l'alumne NO veu la nota mentre l'activitat no estigui TANCAT (estat=2).
                // Mostrem només si ha enviat o no, sense puntuació. El professor sempre veu la nota.
                const esExamen = Boolean(activitat?.isExamen || Number(activitat?.is_examen) === 1);
                const estaTancat = Number(activitat?.estat) === 2;
                const amagarNota = esExamen && !estaTancat && !isTeacher;
                if (amagarNota) {
                    const haEnviat = Number(ele.intents || 0) > 0;
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Tag color={haEnviat ? 'blue' : 'default'} style={{ margin: 0, fontWeight: 600 }}>
                                {haEnviat ? 'Enviat' : 'Pendent'}
                            </Tag>
                        </div>
                    );
                }

                // Calcular o llegir la nota final de l'exercici (aplicant penalitzacions dinàmiques per intents fallits)
                let finalScore: number | null = null;

                if (hecho) {
                    // La nota base per haver completat amb èxit l'exercici és la nota original de la solució (normalment 100)
                    let baseScore = 100;
                    if (ele.nota !== null && ele.nota !== undefined && Number(ele.nota) > 0) {
                        baseScore = Number(ele.nota);
                    }

                    // Obtenir penalització configurada al checks
                    let penaltyPerAttempt = 0;
                    if (ele.checks && typeof ele.checks === 'string') {
                        const m = ele.checks.match(/PENALTY:(\d+(\.\d+)?)/);
                        if (m) penaltyPerAttempt = Number(m[1]) || 0;
                        else if (ele.checks.includes('"penalitzacioPerIntent"')) {
                            try {
                                const hIdx = ele.checks.indexOf('#');
                                const jStr = hIdx !== -1 ? ele.checks.substring(hIdx + 1).trim() : ele.checks.trim();
                                const pJson = JSON.parse(jStr);
                                if (pJson.penalitzacioPerIntent) penaltyPerAttempt = Number(pJson.penalitzacioPerIntent) || 0;
                            } catch (_) {}
                        }
                    }

                    // Els intents fallits són els intents totals menys l'intent encertat (mínim 0)
                    const totalAttempts = Math.max(1, Number(ele.intents) || 1);
                    const failedAttempts = Math.max(0, totalAttempts - 1);
                    const penaltyTotal = failedAttempts * penaltyPerAttempt;

                    finalScore = Math.max(0, Math.min(100, Math.round(baseScore - penaltyTotal)));
                } else if (ele.nota !== null && ele.nota !== undefined) {
                    finalScore = Math.round(Number(ele.nota));
                } else if (progreso > 0) {
                    finalScore = progreso;
                }

                // Determinació del color de la barra segons la nota
                const strokeColor = !hecho
                    ? (progreso >= 50 ? BbddColors.colors.color6 : '#1890ff')
                    : (finalScore !== null && finalScore < 50 ? '#ff4d4f' : (finalScore !== null && finalScore < 80 ? '#faad14' : '#52c41a'));

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                        <Tooltip title={
                            hecho
                                ? (finalScore !== null ? `Completat amb èxit! Nota obtinguda: ${finalScore}/100 (${ele.intents || 1} intents)` : "Exercici superat!")
                                : (ele.intents > 0 ? `En progrés (${ele.intents} intents fallits)` : "Pendent de resoldre")
                        }>
                            <Progress
                                type="circle"
                                percent={hecho ? (finalScore !== null ? finalScore : 100) : progreso}
                                width={44}
                                strokeColor={strokeColor}
                                format={(pct) => {
                                    if (hecho) {
                                        return (
                                            <span style={{ fontSize: 11, fontWeight: 700, color: strokeColor }}>
                                                {finalScore !== null ? `${finalScore}` : '100'}
                                            </span>
                                        );
                                    }
                                    if (progreso === 0) {
                                        return <span style={{ fontSize: 10, color: '#8c8c8c' }}>0%</span>;
                                    }
                                    return <span style={{ fontSize: 10, fontWeight: 600 }}>{`${pct}%`}</span>;
                                }}
                            />
                        </Tooltip>
                        {hecho && (
                            <span style={{ fontSize: 10, color: strokeColor, fontWeight: 600 }}>
                                {finalScore !== null ? `${finalScore}/100` : '100 pts'}
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            key: 'actions',
            title: 'Accions',
            align: 'center',
            width: 170,
            render: (e, ele) => {
                const canAccess = (ele.progres === 0 && activitat?.estat === 3) ||
                    isTeacher ||
                    (ele.progres !== 0 && activitat?.isExamen && activitat.estat === 3);

                return (
                    <Space wrap>
                        {canAccess && (
                            <Tooltip title={modoDesafio ? "Obrir a l'IDE SQL en nova pestanya (Modo Desafío)" : "Accedir a l'exercici"}>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    icon={modoDesafio ? <ThunderboltOutlined style={{ fontSize: 16 }} /> : <BiArrowFromLeft />}
                                    onClick={() => {
                                        if (modoDesafio) {
                                            const isNoSql = ele.tipus === 'NoSQL';
                                            const url = getIdeSqlUrl({
                                                idPractica: id_activitat,
                                                idProblema: ele.id,
                                                openPanel: 'none',
                                                isDesafio: true,
                                                isExamen: Boolean(activitat?.isExamen),
                                                userId: userId ? String(userId) : undefined,
                                                engine: isNoSql ? 'mongodb' : undefined
                                            });
                                            window.open(url, '_blank');
                                        } else {
                                            navigate(`/database/activitats/${id_activitat}/problemes/${ele.id}`);
                                        }
                                    }}
                                    style={{
                                        backgroundColor: modoDesafio ? '#722ed1' : BbddColors.colors.color4,
                                        border: "none",
                                        boxShadow: modoDesafio ? '0 2px 8px rgba(114, 46, 209, 0.4)' : undefined
                                    }}
                                />
                            </Tooltip>
                        )}


                        {/* Recompensas Gamificadas */}
                        {ele.has_rewards === 1 && ele.reward_obtained === 0 && ele.progres >= 1 && (
                            <Tooltip title="Reclamar Recompensa">
                                <Button
                                    shape="circle"
                                    icon={<GiftOutlined />}
                                    onClick={() => {
                                        if (false) setRecompensaItems([
                                            {
                                                tipo: 'PUNTUACION',
                                                valor: 15,
                                                nom: 'Punts de Base de Dades'
                                            }
                                        ]);
                                        if (false) setRecompensaModalVisible(true);
                                        handleClaimRewardClick(ele);
                                    }}

                                    style={{ backgroundColor: 'gold', border: 'none', color: '#000' }}
                                />
                            </Tooltip>
                        )}

                        {/* [LOCALHOST] Forçar obtenció de recompensa ignorant requisits (només proves) */}
                        {IS_LOCALHOST && ele.has_rewards === 1 && ele.reward_obtained === 0 && (
                            <Tooltip title="[LOCALHOST] Forçar recompensa (ignora requisits)">
                                <Button
                                    shape="circle"
                                    icon={<ThunderboltOutlined />}
                                    onClick={() => handleForceClaimRewardClick(ele)}
                                    style={{ backgroundColor: '#ff7875', border: 'none', color: '#fff' }}
                                />
                            </Tooltip>
                        )}

                        {isTeacher && (
                            <Tooltip title="Premis i Recompenses">
                                <Button
                                    shape="circle"
                                    icon={<TrophyOutlined />}
                                    onClick={() => openPremiosModal(ele)}
                                    style={{ backgroundColor: '#faad14', color: '#fff', border: "none" }}
                                />
                            </Tooltip>
                        )}
                        {isTeacher && (
                            <Tooltip title="Editar exercici">
                                <Button
                                    shape="circle"
                                    icon={<FaEdit />}
                                    onClick={() => handleNuevo(ele)}
                                    style={{ backgroundColor: '#1890ff', color: '#fff', border: "none" }}
                                />
                            </Tooltip>
                        )}

                        {isTeacher && (ele.tipus === 'ER' || ele.tipus === 'Script' || ele.tipus === 'Relacional') && (
                            <Tooltip title="Configurar Tests i Rúbrica (100 pts)">
                                <Button
                                    shape="circle"
                                    icon={<SettingOutlined />}
                                    onClick={() => {
                                        setSelected(ele);
                                        setConfigTestsExercise(ele);
                                        setConfigTestsModalVisible(true);
                                    }}
                                    style={{ backgroundColor: '#722ed1', color: '#fff', border: "none" }}
                                />
                            </Tooltip>
                        )}

                        {isTeacher && (ele.tipus !== 'ER' && ele.tipus !== 'Script' && ele.tipus !== 'Relacional') && (
                            <Tooltip title="Configurar Tests i Regles SQL">
                                <Button
                                    shape="circle"
                                    icon={<SettingOutlined />}
                                    onClick={() => {
                                        setSelected(ele);
                                        setConfigSqlTestsExercise(ele);
                                        setConfigSqlTestsModalVisible(true);
                                    }}
                                    style={{ backgroundColor: '#13c2c2', color: '#fff', border: "none" }}
                                />
                            </Tooltip>
                        )}

                        {activitat?.estat === 4 && ele.progres === 0 && ele.reclamar === null && (
                            <Tooltip title="Demanar Revisió">
                                <Button
                                    shape="circle"
                                    icon={<FaQuestionCircle />}
                                    onClick={() => reclamar(ele)}
                                    style={{ backgroundColor: BbddColors.colors.color6, border: "none", color: "#fff" }}
                                />
                            </Tooltip>
                        )}

                        {ele.intents > 0 && (
                            <Tooltip title="Visualitzar enviaments">
                                <Button
                                    shape="circle"
                                    icon={<FaEye />}
                                    onClick={() => checkElement(ele)}
                                    style={{ backgroundColor: BbddColors.colors.color3, border: 'none', color: '#fff' }}
                                />
                            </Tooltip>
                        )}
                    </Space>
                );
            }
        }
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    return (
        <div style={{ background: '#f8f9fb', padding: '16px 20px', minHeight: 'calc(100vh - 120px)' }}>
            {/* Header info & Buttons */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 16,
                flexWrap: 'wrap',
                gap: 12
            }}>
                <div>
                    <Typography.Title level={3} style={{ margin: 0, fontWeight: 700 }}>
                        {activitat?.nom || `Activitat #${id_activitat}`}
                    </Typography.Title>
                    <Text type="secondary">
                        Llistat d'exercicis, tipus de resolució i avaluació automàtica
                    </Text>
                </div>

                <Space wrap align="center">
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        background: modoDesafio ? '#f9f0ff' : '#f0f2f5',
                        border: modoDesafio ? '1px solid #d3adf7' : '1px solid #d9d9d9',
                        padding: '4px 12px',
                        borderRadius: 20
                    }}>
                        <ThunderboltOutlined style={{ color: modoDesafio ? '#722ed1' : '#8c8c8c' }} />
                        <Text strong style={{ fontSize: 13, color: modoDesafio ? '#722ed1' : '#595959' }}>
                            Modo Desafío
                        </Text>
                        <Switch
                            checked={modoDesafio}
                            onChange={handleToggleModoDesafio}
                            style={{ backgroundColor: modoDesafio ? '#722ed1' : undefined }}
                        />
                    </div>


                    {isTeacher && (
                        <>
                            <Button
                                icon={<FileExcelOutlined />}
                                onClick={() => setImportExcelVisible(true)}
                                style={{
                                    backgroundColor: '#237804',
                                    color: '#fff',
                                    borderColor: '#237804',
                                    fontWeight: 600
                                }}
                            >
                                Importar Excel
                            </Button>
                            <Button
                                type="primary"
                                icon={<BiPlus />}
                                onClick={() => handleNuevo()}
                                style={{
                                    backgroundColor: AvaluacioColors.colors.color6,
                                    borderColor: AvaluacioColors.colors.color6,
                                    fontWeight: 600
                                }}
                            >
                                Nou Exercici
                            </Button>
                        </>
                    )}
                </Space>
            </div>

            {/* Statistic Cards like Jutge */}
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Total Exercicis</span>}
                            value={stats.total}
                            prefix={<FaDatabase style={{ color: '#1890ff', marginRight: 6 }} />}
                            valueStyle={{ color: '#1890ff', fontWeight: 700, fontSize: 24 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Completats</span>}
                            value={stats.completed}
                            suffix={`/ ${stats.total}`}
                            prefix={<FaCheck style={{ color: '#52c41a', marginRight: 6 }} />}
                            valueStyle={{ color: '#52c41a', fontWeight: 700, fontSize: 24 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Progrés Mitjà</span>}
                            value={stats.avgProgress}
                            suffix="%"
                            prefix={<AreaChartOutlined style={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', marginRight: 6 }} />}
                            valueStyle={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', fontWeight: 700, fontSize: 24 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Intents Registrats</span>}
                            value={stats.attempts}
                            prefix={<FireOutlined style={{ color: '#fa8c16', marginRight: 6 }} />}
                            valueStyle={{ color: '#fa8c16', fontWeight: 700, fontSize: 24 }}
                        />
                    </Card>
                </Col>
            </Row>

            <Card
                bordered={false}
                style={{
                    boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                    background: '#fff',
                    borderRadius: '16px',
                    overflow: 'hidden'
                }}
                bodyStyle={{ padding: 0 }}
            >
                <Table
                    {...tableProps}
                    columns={columns}
                    size="middle"
                    showHeader={true}
                    dataSource={filteredDades}
                    rowKey="id"
                    bordered={false}
                    pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50'],
                        defaultPageSize: 10
                    }}
                />
            </Card>

            {!loading && (
                <FloatButton.Group
                    trigger="click"
                    type="primary"
                    style={{ insetInlineStart: 97 }}
                    icon={<IoOptions />}
                >
                    {isTeacher && (
                        <>
                            <FloatButton
                                shape="circle"
                                tooltip="Importar Excel"
                                onClick={() => setImportExcelVisible(true)}
                                style={{ backgroundColor: '#237804' }}
                                icon={<FileExcelOutlined />}
                            />
                            <FloatButton
                                shape="circle"
                                tooltip="Nou Exercici"
                                onClick={() => handleNuevo()}
                                style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                icon={<BiPlus />}
                            />
                        </>
                    )}
                    <FloatButton
                        shape="circle"
                        type="default"
                        tooltip="Actualitzar"
                        onClick={() => checkDades()}
                        style={{ backgroundColor: BbddColors.colors.color6 }}
                        icon={<BiRefresh />}
                    />
                </FloatButton.Group>
            )}

            {modal && (
                <RevisioModal
                    element={selected}
                    visible={modal}
                    onClose={closeModal}
                    id_practica={id_activitat}
                />
            )}

            {modalNuevo && (
                <NouExerciciBbddModal
                    id_activitat={id_activitat}
                    id_aula={activitat?.id_aula}
                    element={selected}
                    visible={modalNuevo}
                    onClose={closeNouModal}
                />
            )}

            {importExcelVisible && (
                <ImportarExercicisBbddExcelModal
                    id_activitat={id_activitat || '0'}
                    visible={importExcelVisible}
                    onClose={() => setImportExcelVisible(false)}
                    onSuccess={() => checkDades()}
                />
            )}

            {configTestsModalVisible && configTestsExercise && (
                <ConfiguracioTestsDissenyModal
                    visible={configTestsModalVisible}
                    tipus={configTestsExercise.tipus}
                    exerciseName={configTestsExercise.nom || configTestsExercise.prac}
                    solutionRaw={configTestsExercise.correccio || ''}
                    initialChecksStr={configTestsExercise.checks || ''}
                    onClose={async (savedConfig) => {
                        if (savedConfig) {
                            try {
                                const prefix = configTestsExercise.tipus === 'ER' ? 'ER-VALIDATION' : (configTestsExercise.tipus === 'Script' ? 'SCRIPT-VALIDATION' : 'RELATIONAL-VALIDATION');
                                const jsonConfig = JSON.stringify(savedConfig);
                                const finalChecks = `${prefix}#${jsonConfig}`;

                                const payload = {
                                    id: configTestsExercise.id,
                                    nom: configTestsExercise.nom || configTestsExercise.prac,
                                    descripcio: configTestsExercise.descripcio || configTestsExercise.enunciat,
                                    enunciat: configTestsExercise.enunciat || configTestsExercise.descripcio,
                                    dificultat: configTestsExercise.dificultat || 'beginner',
                                    tipus: configTestsExercise.tipus,
                                    correccio: configTestsExercise.correccio || '',
                                    checks: finalChecks
                                };

                                await PostBbddActivitatIdProblema(id_activitat || '0', payload);
                                import("antd").then(({ message }) => message.success("Rúbrica de tests actualitzada correctament!"));
                                checkDades();
                            } catch (err: any) {
                                import("antd").then(({ message }) => message.error("Error al desar la configuració: " + (err?.message || err)));
                            }
                        }
                        setConfigTestsModalVisible(false);
                        setConfigTestsExercise(null);
                    }}
                />
            )}

            {configSqlTestsModalVisible && configSqlTestsExercise && (
                <ConfiguracioTestsSqlModal
                    visible={configSqlTestsModalVisible}
                    tipus={configSqlTestsExercise.tipus}
                    exerciseName={configSqlTestsExercise.nom || configSqlTestsExercise.prac}
                    solutionRaw={configSqlTestsExercise.correccio || ''}
                    initialChecksStr={configSqlTestsExercise.checks || ''}
                    onClose={async (savedChecksStr, savedConfig) => {
                        if (savedChecksStr !== null && savedChecksStr !== undefined) {
                            try {
                                const payload = {
                                    id: configSqlTestsExercise.id,
                                    nom: configSqlTestsExercise.nom || configSqlTestsExercise.prac,
                                    descripcio: configSqlTestsExercise.descripcio || configSqlTestsExercise.enunciat,
                                    enunciat: configSqlTestsExercise.enunciat || configSqlTestsExercise.descripcio,
                                    dificultat: configSqlTestsExercise.dificultat || 'beginner',
                                    tipus: configSqlTestsExercise.tipus,
                                    correccio: configSqlTestsExercise.correccio || '',
                                    checks: savedChecksStr
                                };

                                await PostBbddActivitatIdProblema(id_activitat || '0', payload);
                                import("antd").then(({ message }) => message.success("Regles i comprovacions SQL actualitzades correctament!"));
                                checkDades();
                            } catch (err: any) {
                                import("antd").then(({ message }) => message.error("Error al desar la configuració SQL: " + (err?.message || err)));
                            }
                        }
                        setConfigSqlTestsModalVisible(false);
                        setConfigSqlTestsExercise(null);
                    }}
                />
            )}

            {rankingsVisible && selected && (
                <PremiosModal
                    idProblema={selected.id + ""}
                    idActivitat={id_activitat + ""}
                    origenTipo="BBDD"
                    visible={rankingsVisible}
                    onClose={(refresh: boolean) => closeModalRanking(refresh)}
                />
            )}

            {showBattle && (
                <JavaMon
                    userId={userId + ""}
                    onClose={() => {
                        setShowBattle(false);
                    }}
                    onSuccess={() => {
                        onBattleSuccess();
                    }}
                    forcedJavamon={battleJavamon}
                />
            )}

            <RecompensaSummaryModal
                visible={recompensaModalVisible}

                rewards={recompensaItems}
                selectableMode={selectableMode}
                selectionOptions={selectionOptions}
                onConfirmSelection={handleConfirmSelection}
                currentAttempts={pendingSelectionItem?.intents ?? 0}
                currentNota={pendingSelectionItem?.nota ?? 100}
                currentTimeSeconds={pendingSelectionItem?.tiempo_empleado_segundos}
                onClose={() => {
                    setRecompensaModalVisible(false);
                    if (pendingJavamonBattle) {
                        setActiveRewardData({
                            idActivitat: id_activitat + "",
                            idProblema: pendingJavamonBattle.idProblema,
                            userId: userId + ""
                        });
                        setBattleJavamon(pendingJavamonBattle.javamon);
                        setShowBattle(true);
                        setPendingJavamonBattle(null);
                    }
                }}
                status="ok"
                message="¡Enhorabona! Has obtingut aquesta recompensa per resoldre l'exercici de Base de Dades."
            />
        </div>
    );
};

export default ActivitatsIdExercicis;
